module.exports = __webpack_public_path__ + "static/media/gray_left.cfe87c88.svg";